import { render, staticRenderFns } from "./CategoriesPage.vue?vue&type=template&id=5aca9c82&scoped=true&"
import script from "./CategoriesPage.vue?vue&type=script&lang=js&"
export * from "./CategoriesPage.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesPage.vue?vue&type=style&index=0&id=5aca9c82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aca9c82",
  null
  
)

export default component.exports